import React from "react";

import { ChevronRightOutlined } from "@toddle-edu/ds-icons";

import classes from "./ArrowWithCount.scss";

const ArrowWithCount = props => {
  const { count, countStyle } = props;

  return (
    <div className={classes.container}>
      {count != 0 && (
        <div className={classes.count} style={countStyle}>
          {count}
        </div>
      )}
      <ChevronRightOutlined size={"xx-small"} variant={"subtle"} />
    </div>
  );
};

export default ArrowWithCount;
